<template>
  <div class="modal-wrap">
    <el-dialog
      title="制作时长"
      :visible.sync="dialogVisible"
      width="420px"
      :close-on-click-modal="false"
    >
      <div class="form-wrap">
        <el-form
          label-width="100px"
          :model="formData"
          ref="tableRef"
          :rules="rules"
        >
          <el-form-item label="制作时长：" prop="productTime">
            <el-input
              placeholder="请输入内容"
              v-model="formData.productTime"
              type="number"
            >
              <template slot="append">小时</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="saveTime"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { modifyMaterial } from "@/api/materialManage.js";
export default {
  name: "TimeModal",
  data() {
    return {
      dialogVisible: false,
      totalData: null,
      formData: {
        productTime: "",
      },
      loading: false,
      rules: {
        productTime: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value == "") {
                callback(new Error("制作时长必填"));
              } else if (parseInt(value) <= 0) {
                callback(new Error("制作时长不规范"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    editData(data) {
      this.totalData = data; //保存所有数据
      this.formData.productTime = data.productTime;
      this.dialogVisible = true;
    },
    saveTime() {
      this.$refs.tableRef.validate((valid) => {
        if (valid) {
          let parmas = this.totalData;
          parmas.productTime = this.formData.productTime;
          this.loading = true;
          modifyMaterial(parmas).then((res) => {
            this.loading = false;
            if (res.code === "0000") {
              this.$message({
                message: "制作时间修改成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.$emit("refresh", false);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  /deep/ .el-form-item__label {
    height: 30px;
    line-height: 30px;
  }
}
</style>